import { COLORS, Divider, styled } from '@msdk/ui'

export const SidebarDivider = styled(Divider)`
  background-color: ${COLORS.white.outlinedBorder};
  margin: 20px 0;
  &.horizontal-margin {
    margin-left: 12px;
    margin-right: 12px;
  }
`
